import React, { ReactNode, useEffect, useState } from "react";
import ReactDOM from "react-dom";

interface PortalProps {
  children: ReactNode;
  targetId?: string;
}

const Portal: React.FC<PortalProps> = ({ children, targetId = "sidebar-popover-root" }) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const el = document.getElementById(targetId);
    setContainer(el);
  }, [targetId]);

  if (!container) return null;
  return ReactDOM.createPortal(children, container);
};

export default Portal;
